var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwimmingPoolStairs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.75 22.814a6.008 6.008 0 006.375-1.207 6 6 0 008.25 0 6 6 0 007.875.326m-6-3.183v-15a3 3 0 016 0m-15 15v-15a3 3 0 016 0m-6 7.5h9m-9 4.5h9m-9-9h9",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MS41cHg7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNLjc1LDIyLjgxNGE2LjAwOCw2LjAwOCwwLDAsMCw2LjM3NS0xLjIwNyw2LDYsMCwwLDAsOC4yNSwwLDYsNiwwLDAsMCw3Ljg3NS4zMjYiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTE3LjI1LDE4Ljc1di0xNWEzLDMsMCwwLDEsNiwwIi8+PHBhdGggY2xhc3M9ImEiIGQ9Ik04LjI1LDE4Ljc1di0xNWEzLDMsMCwwLDEsNiwwIi8+PGxpbmUgY2xhc3M9ImEiIHgxPSI4LjI1IiB5MT0iMTEuMjUiIHgyPSIxNy4yNSIgeTI9IjExLjI1Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSI4LjI1IiB5MT0iMTUuNzUiIHgyPSIxNy4yNSIgeTI9IjE1Ljc1Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSI4LjI1IiB5MT0iNi43NSIgeDI9IjE3LjI1IiB5Mj0iNi43NSIvPjwvc3ZnPgo=";
export { SvgSwimmingPoolStairs as ReactComponent };